import './Section6Component.css'
import whatsapp from './images/whatsapp.png'

export const Section6Component = () => {
    return (
        <div className="blue_bg py-5 px-2 px-lg-0" id='contactanos'>
            <div className="container_2 text-center white_cl">
                <h2 className='rubik_regular'>
                    Conoce más de esta gran <span className='rubik_bold'>Unión </span>
                    de la que tú también haces parte 
                </h2>
                <div>
                    <h6 className='my-3'>Escríbenos a</h6>
                    <div className="whatsapp-container white_bg"
                        onClick={e => window.open('https://wa.me/+573183349462')}>
                        <img src={whatsapp} alt="Logo WhatsApp" className='img-fluid img_logo_wpp'/>
                        <h5 className='rubik_medium black_cl mb-0'>WhatsApp</h5>
                    </div>
                    <div className="d-flex flex-column mt-4">
                        <h5>o llámanos a la Línea Nacional</h5>
                        <h2 className='rubik_bold'>01 8000 111 999</h2>
                        <h5>Encuentra la línea de tu ciudad 
                            <span>
                                <a href="https://bancounion.com/wps/portal/bancounion/web/servicio-cliente/lineas-atencion" className='yellow_cl text-decoration-none' style={{textDecoration:'underline'}} target="_blank" rel='noreferrer'> Aquí
                                </a>
                            </span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    )
}